var map = {
	"./action.svg": 204,
	"./adventure.svg": 205,
	"./advertorial.svg": 206,
	"./album.svg": 207,
	"./analysis.svg": 208,
	"./anchor.svg": 209,
	"./android-block.svg": 210,
	"./android-small.svg": 211,
	"./android.svg": 212,
	"./angle-down.svg": 213,
	"./angle-left.svg": 214,
	"./angle-right.svg": 215,
	"./angle-up.svg": 216,
	"./aquarius.svg": 217,
	"./arcade.svg": 218,
	"./aries.svg": 219,
	"./arrow-down.svg": 220,
	"./arrow-left.svg": 221,
	"./arrow-right.svg": 222,
	"./arrow-up.svg": 223,
	"./arrow.svg": 224,
	"./art-director.svg": 225,
	"./astrology.svg": 226,
	"./author-avator.svg": 227,
	"./author.svg": 228,
	"./authoranchor.svg": 229,
	"./authorwhite.svg": 230,
	"./automobile.svg": 231,
	"./backward.svg": 232,
	"./bookmark.svg": 233,
	"./books-vikatan.svg": 234,
	"./brandconnect.svg": 235,
	"./breaking-news.svg": 236,
	"./bullet-arrow.svg": 237,
	"./bundle.svg": 238,
	"./business.svg": 239,
	"./calendar.svg": 240,
	"./cancel.svg": 241,
	"./cancer.svg": 242,
	"./canvas.svg": 243,
	"./capricorn.svg": 244,
	"./cartoonist.svg": 245,
	"./cinema.svg": 246,
	"./clapboard.svg": 247,
	"./clipboard.svg": 248,
	"./close.svg": 249,
	"./comment.svg": 250,
	"./corona-updates-icon.svg": 251,
	"./creative-director.svg": 252,
	"./cricket.svg": 253,
	"./crime.svg": 254,
	"./data.svg": 255,
	"./designed.svg": 256,
	"./double-arrow.svg": 257,
	"./downarrow.svg": 258,
	"./download.svg": 259,
	"./edit.svg": 260,
	"./edited-by.svg": 261,
	"./email.svg": 262,
	"./environment.svg": 263,
	"./exclusivedeals.svg": 264,
	"./facebook-bg.svg": 265,
	"./facebook-icon.svg": 266,
	"./facebook.svg": 267,
	"./filter-icon.svg": 268,
	"./filter.svg": 269,
	"./food-stylist.svg": 270,
	"./forward.svg": 271,
	"./gallery.svg": 272,
	"./game-shop.svg": 273,
	"./gemini.svg": 274,
	"./group.svg": 275,
	"./gzhome.svg": 276,
	"./gzsports.svg": 277,
	"./gztrending.svg": 278,
	"./health.svg": 279,
	"./hexbackground.svg": 280,
	"./home.svg": 281,
	"./humoursatire-entertainment.svg": 282,
	"./icon-apple.svg": 283,
	"./icon-appstore.svg": 284,
	"./icon-audio-app-store.svg": 285,
	"./icon-audio-fb.svg": 286,
	"./icon-audio-instagram.svg": 287,
	"./icon-audio-next.svg": 288,
	"./icon-audio-play-store.svg": 289,
	"./icon-audio-previous.svg": 290,
	"./icon-audio-twitter.svg": 291,
	"./icon-audio-whatsapp.svg": 292,
	"./icon-copy.svg": 293,
	"./icon-episode.svg": 294,
	"./icon-facebook.svg": 295,
	"./icon-google-play.svg": 296,
	"./icon-headset.svg": 297,
	"./icon-home-plus.svg": 298,
	"./icon-login.svg": 299,
	"./icon-open-in-new.svg": 300,
	"./icon-pause.svg": 301,
	"./icon-play.svg": 302,
	"./icon-playstore.svg": 303,
	"./icon-premium.svg": 304,
	"./icon-share.svg": 305,
	"./icon-star.svg": 306,
	"./icon-timer.svg": 307,
	"./icon-twitter.svg": 308,
	"./icon-user.svg": 309,
	"./icon-video.svg": 310,
	"./icon-whatsapp.svg": 311,
	"./illustrator-t1.svg": 312,
	"./illustrator.svg": 313,
	"./infographer.svg": 314,
	"./instagram.svg": 315,
	"./interviews.svg": 316,
	"./ios-block.svg": 317,
	"./ios-small.svg": 318,
	"./ios.svg": 319,
	"./jokes.svg": 320,
	"./leo.svg": 321,
	"./libra.svg": 322,
	"./lifestyle.svg": 323,
	"./line-arrow-next.svg": 324,
	"./line-arrow-prev.svg": 325,
	"./linkedin.svg": 326,
	"./listicle.svg": 327,
	"./live-chat.svg": 328,
	"./liveupdate.svg": 329,
	"./log green.svg": 330,
	"./log grey.svg": 331,
	"./log white.svg": 332,
	"./logic.svg": 333,
	"./login-facebook.svg": 334,
	"./login-google.svg": 335,
	"./login.svg": 336,
	"./logout-mobile.svg": 337,
	"./logout.svg": 338,
	"./longform.svg": 339,
	"./magazines.svg": 340,
	"./mail.svg": 341,
	"./menu-search.svg": 342,
	"./microphone.svg": 343,
	"./minus.svg": 344,
	"./mobile-share.svg": 345,
	"./moderated.svg": 346,
	"./more-outline.svg": 347,
	"./my-vikatan-logo.svg": 348,
	"./mynews.svg": 349,
	"./myvikatanbadge.svg": 350,
	"./narrated.svg": 351,
	"./news.svg": 352,
	"./newsletter.svg": 353,
	"./newslettericon.svg": 354,
	"./olympic.svg": 355,
	"./online-news.svg": 356,
	"./pause.svg": 357,
	"./pdf.svg": 358,
	"./pen.svg": 359,
	"./personalise.svg": 360,
	"./phone.svg": 361,
	"./photo.svg": 362,
	"./photographer.svg": 363,
	"./photostory.svg": 364,
	"./pisces.svg": 365,
	"./play.svg": 366,
	"./plus.svg": 367,
	"./podcast.svg": 368,
	"./podcast_vikatan_menu.svg": 369,
	"./poems.svg": 370,
	"./politics.svg": 371,
	"./premium.svg": 372,
	"./producer.svg": 373,
	"./proofread.svg": 374,
	"./published-by.svg": 375,
	"./published.svg": 376,
	"./rain.svg": 377,
	"./rss.svg": 378,
	"./rupee.svg": 379,
	"./sagitarius.svg": 380,
	"./scorpio.svg": 381,
	"./script-writer.svg": 382,
	"./scripted.svg": 383,
	"./search.svg": 384,
	"./share-alt.svg": 385,
	"./share.svg": 386,
	"./sharechat.svg": 387,
	"./shortform.svg": 388,
	"./shortstories.svg": 389,
	"./shortvideo.svg": 390,
	"./slider-next.svg": 391,
	"./slider-prev.svg": 392,
	"./socialshare.svg": 393,
	"./sort.svg": 394,
	"./sound.svg": 395,
	"./speaker.svg": 396,
	"./speakeraudio.svg": 397,
	"./spiritual.svg": 398,
	"./sponsored.svg": 399,
	"./sports.svg": 400,
	"./star.svg": 401,
	"./stories.svg": 402,
	"./strategy.svg": 403,
	"./stylist.svg": 404,
	"./subscribe-vikatan.svg": 405,
	"./success-icon.svg": 406,
	"./tag.svg": 407,
	"./taurus.svg": 408,
	"./technology.svg": 409,
	"./text.svg": 410,
	"./textsms.svg": 411,
	"./thodargal.svg": 412,
	"./thump.svg": 413,
	"./tick.svg": 414,
	"./trending.svg": 415,
	"./twitter-icon.svg": 416,
	"./twitter.svg": 417,
	"./uparrow.svg": 418,
	"./update-black.svg": 419,
	"./user-square.svg": 420,
	"./user.svg": 421,
	"./v-plus-logo.svg": 422,
	"./video-editor.svg": 423,
	"./video-icon.svg": 424,
	"./video-play.svg": 425,
	"./video.svg": 426,
	"./videographer.svg": 427,
	"./vikatan-play-logo-red.svg": 428,
	"./vikatan-play.svg": 429,
	"./vikatan-tv.svg": 430,
	"./vikatan.svg": 431,
	"./vikatanconnect.svg": 432,
	"./vikatanplay.svg": 433,
	"./vikatanspl.svg": 434,
	"./vikatantv.svg": 435,
	"./virgo.svg": 436,
	"./whatsapp-icon.svg": 437,
	"./whatsapp-icon1.svg": 438,
	"./whatsapp.svg": 439,
	"./women-home.svg": 440,
	"./writtenarticles.svg": 441,
	"./writtenstory.svg": 442,
	"./youtube.svg": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 203;